<template>
  <div class="activityList-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-select
        v-model="params.gameType"
        size="small"
        clearable
        placeholder="活动状态"
        @change="queryGameList('status')"
      >
        <el-option
          v-for="item in gameTypes"
          :value="item.value"
          :label="item.label"
          :key="item.value"
        ></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="searchActive('status')"
        >搜索</el-button
      >
      <el-button type="primary" size="small" @click="activeAction('add')"
        >+新增游戏</el-button
      >
    </div>
    <!-- 表格数据 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="id"
        label="ID"
        align="center"
        :show-overflow-tooltip="true"
        min-width="220"
        fixed
      ></el-table-column>
      <el-table-column
        prop="cover"
        label="游戏封面"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.cover"
            :width="'90px'"
            :height="'90px'"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="bgCover"
        label="游戏背景"
        align="center"
        min-width="120"
      >
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.bgCover"
            :width="'90px'"
            :height="'90px'"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="gameScreenshots"
        label="游戏截屏"
        align="center"
        width="300"
      >
        <template slot-scope="scope">
          <span
            v-if="
              !scope.row.gameScreenshots || !scope.row.gameScreenshots.length
            "
            >未知</span
          >
          <div v-else class="picturePreview">
            <decrypt-img
              style="width: 50px; height: 50px; margin-right: 5px;"
              :src="checkUrl(item) + item"
              :iPreviewSrcList="[]"
              fit="fill"
              v-for="(item, i) in scope.row.gameScreenshots"
              :key="i"
            ></decrypt-img>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="gameScreenshots" label="游戏截屏" align="center" min-width="120">
        <template slot-scope="scope">
          <img-load
            :src="imgUrl + scope.row.gameScreenshots"
            :width="'90px'"
            :height="'90px'"
          />
        </template>
      </el-table-column> -->
      <el-table-column
        prop="name"
        label="游戏名称"
        align="center"
        :show-overflow-tooltip="true"
        width="220"
      ></el-table-column>
      <el-table-column
        prop="password"
        label="密码"
        align="center"
        :show-overflow-tooltip="true"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="coin"
        label="游戏价格"
        align="center"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="detail"
        label="游戏详情"
        align="center"
        :show-overflow-tooltip="true"
        width="300"
      >
        <template slot-scope="scope">{{ scope.row.detail || "未知" }}</template>
      </el-table-column>
      <el-table-column
        prop="gameType"
        label="游戏类型"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.gameType == 'pc'">pc</div>
          <div v-else-if="scope.row.gameType == 'android'">android</div>
          <div v-else>--</div>
        </template>
      </el-table-column>

      <el-table-column
        prop="operating"
        label="操作"
        align="center"
        width="120"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="activeAction('edit', scope.row)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="remove(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[5, 10, 15, 20]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @size-change="changeSize"
      :total="total"
      @current-change="changeCurrent"
    ></el-pagination>
    <!--新增、编辑tag弹窗-->
    <active-action
      ref="activeAction"
      @handlerList="handlerActiveList"
    ></active-action>
  </div>
</template>
<script>
import ActiveAction from "./components/activeAction";
import API from "@/api";
import { paramsFilter } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      time: "",
      imgUrl: baseConfig.imgUrl,
      // 是否开启
      gameTypes: [
        {
          label: "pc",
          value: "pc",
        },
        {
          label: "android",
          value: "android",
        },
      ],
      params: {
        status: "",
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  components: {
    ActiveAction,
  },
  created() {
    this.queryGameList();
  },
  methods: {
    remove(row) {
      this.$confirm(`确认是否删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          let delData = {
            id: row.id,
          };
          API.delGame(delData)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.queryGameList();
              } else {
                this.$message({
                  type: "success",
                  message: "删除失败!",
                });
              }
              // this.getModules();
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "服务器异常!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    checkUrl(domain) {
      if (!domain) {
        return "";
      }
      var patt = /^http(s)?:\/\/.+/;
      if (!patt.test(domain)) {
        if (domain[0] == "/") {
          return this.newImgUrl;
        } else {
          return this.imgUrl;
        }
      } else {
        return "";
      }
    },
    // 请求活动列表
    queryGameList(type) {
      if (type === "status") {
        this.formData.pageNumber = 1;
      }

      this.loading = true;
      let formData = paramsFilter(this.params);
      API.queryGameList(formData)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    // 搜索列表
    searchActive() {
      this.queryGameList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.formparamsData.pageNumber = 1;
      this.queryGameList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.queryGameList();
    },
    // 编辑活动成功回掉
    handlerActiveList() {
      this.queryGameList();
    },
    // 新增、删除tags
    activeAction(type, data) {
      this.$refs.activeAction.open(type, data);
    },
  },
};
</script>
<style scoped></style>
